import React, { useState } from 'react'
import { Query } from 'react-apollo'
import moment from 'moment'
import ReactTable from 'react-table'
import { Col, Input as Ip, Select } from 'antd'
import _ from 'lodash'
import FileDownload from 'js-file-download'
import axios from 'axios'
import InfiniteScroll from 'react-infinite-scroller'
import {
  Div, H3, Button, Loading, DynamicButtonLink, P, H4, H5,
} from 'konsys-ui'
import { status, statusText } from '../constants'
import { theme } from '../../../styles/_variables'
import '../list/style-css.css'
import { Wrapper } from '../../../components/trailer-components'
import { TRAILER_INFO } from '../../../constants/graphql/query'
import { getAccessToken, getURL } from '../../../utils/local-data-service'
import { monthConverter } from '../../../utils/util-services'
import PERMISSION from '../../../constants/permissions'

const { color } = theme

const calculateTime = (startTime, endTime) => {
  let timeTh = ''
  let properEndTime = endTime
  let properStartTime = startTime
  if (endTime == null) properEndTime = moment()
  if (moment(properEndTime).diff(properStartTime, 'years') > 0) {
    timeTh += moment(properEndTime).diff(properStartTime, 'years')
    timeTh += ' ปี '
    properStartTime = moment(properStartTime).add(moment(properEndTime).diff(properStartTime, 'years'), 'years')
  }
  if (moment(properEndTime).diff(properStartTime, 'months') > 0) {
    timeTh += moment(properEndTime).diff(properStartTime, 'months')
    timeTh += ' เดือน '
    properStartTime = moment(properStartTime).add(moment(properEndTime).diff(properStartTime, 'months'), 'months')
  }
  timeTh += moment(properEndTime).diff(properStartTime, 'days')
  timeTh += ' วัน '
  return timeTh
}

export default ({ props }) => {
  const [sorted, setSorted] = useState([{ id: 'id', desc: false }])
  return (
    <Wrapper overflow padding='0 0 40px 0' flex>
      <Query
        query={TRAILER_INFO}
        fetchPolicy='cache-and-network'
        variables={{
          id: props.match.params.id,
        }}
      >
        {
          ({
            error, loading, data, refetch,
          }) => {
            if (error) return <p>เกิดข้อผิดพลาด</p>
            if (loading && _.isEmpty(data)) return <Loading center='true' />
            const trailerInfo = data.TrailerInfo
            const usageList = data.TrailerInfo.trailerUsedLog
            return (
              <Div display='flex' flexDirection='column'>
                <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center' padding='0'>
                  <H3 bold color={color.primaryColor} margin='32px 0'>หางพ่วง - ประวัติการใช้งาน</H3>
                  <Div display='flex' flexDirection='row' justifyContent='space-between'>
                  </Div>
                </Div>
              <Div>
                <Div display='flex' flexDirection='row' margin='8px 0 32px 8px'>
                  <H4>ทะเบียนหาง - {trailerInfo.trailerPlate}</H4>
                </Div>
                <Div display='flex' flexDirection='row' margin='8px 0 24px'>
                  <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>วันที่เริ่มใช้งาน</P></Div></Col>
                  <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>วันที่เลิกใช้งาน</P></Div></Col>
                  <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ทะเบียนหัว</P></Div></Col>
                  <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ทะเบียนหาง</P></Div></Col>
                  <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P bold color={color.primaryColor}>ระยะเวลา</P></Div></Col>
                </Div>
                {/* <InfiniteScroll
                  loadMore={() => {
                    dataShow += 10
                    showData = usageList.slice(0, 1)
                    showData = loadMoreLog(usageList)
                  }}
                  hasMore={usageList.length < dataShow}
                  loader={<Loading center='true' />}
                  initialLoad={false}
                  style={{ width: '100%' }}
                > */}
                {
                  _.map(usageList, v => <Div display='flex' flexDirection='row' margin='8px 0 16px'>
                    <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{moment(v.start).format('DD/MM/YYYY')}</P></Div></Col>
                    <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{v.end != null ? moment(v.end).format('DD/MM/YYYY') : 'ใช้ปัจจุบัน'}</P></Div></Col>
                    <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{v.truck.plateNumber}</P></Div></Col>
                    <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{trailerInfo.trailerPlate}</P></Div></Col>
                    <Col md={{ span: 4 }}><Div display='flex' justifyContent='center'><P>{calculateTime(v.start, v.end)}</P></Div></Col>
                  </Div>)
                }
                </Div>
              </Div>
            )
          }
        }
      </Query>
    </Wrapper>
  )
}
